export interface Inputs {
  type: PointType;
  colorDefault: string; // hex string
  colorHover: string; // hex string
  colorClick: string; // hex string
  opacityDefault: number; // 0-1
  opacityHover: number; // 0-1
  opacityClick: number; // 0-1
  edgesOpacityDefault: number; // 0-1
  edgesOpacityHover: number; // 0-1
  edgesOpacityClick: number; // 0-1
}

export enum PointType {
  Start = 'start',
  End = 'end'
}

export { SceneComponent, ComponentInteractionType } from '../SceneComponent';
